import { render, staticRenderFns } from "./BrandTwinTabs.vue?vue&type=template&id=302493de&scoped=true&"
import script from "./BrandTwinTabs.vue?vue&type=script&lang=js&"
export * from "./BrandTwinTabs.vue?vue&type=script&lang=js&"
import style0 from "./BrandTwinTabs.vue?vue&type=style&index=0&id=302493de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302493de",
  null
  
)

export default component.exports